const NIGHT_CHECKOUT_THRESHOLD_HOUR = 22.5;

function timeToDecimalHours(timeStr?: string): number | null {
  if (!timeStr) return null;
  const parts = String(timeStr).trim().split(":");
  const hh = Number(parts[0]);
  const mm = Number(parts[1] ?? 0);
  if (!Number.isFinite(hh) || !Number.isFinite(mm)) return null;
  return hh + mm / 60;
}

function isLateNightCheckout(checkoutTime?: string): boolean {
  const checkout = timeToDecimalHours(checkoutTime);
  if (checkout == null) return false;
  return checkout >= NIGHT_CHECKOUT_THRESHOLD_HOUR || checkout < 3;
}

/** Mismo umbral que roundHours: desde ~8.41 h ya es jornada completa (8.49, 8.5, etc.). */
export function countsAsFullWorkdayHours(
  hours: number,
  fullDayHours: number = 8.5
): boolean {
  const h = Number(hours);
  if (!Number.isFinite(h)) return false;
  return h >= fullDayHours - 0.09;
}

/**
 * Salida nocturna (≥ 22:30): paga jornada completa aunque registró poco menos,
 * solo si NO alcanzó jornada completa (> 7 h y < ~8.41 h).
 * 8.49 h / 8.5 h con salida tarde = jornada completa normal, sin esta leyenda.
 */
export function isNightShiftCompleteSegment(
  segmentHours: number,
  checkoutTime?: string,
  fullDayHours: number = 8.5
): boolean {
  if (countsAsFullWorkdayHours(segmentHours, fullDayHours)) {
    return false;
  }
  const nightShiftMin = 7;
  const almostFullDay = fullDayHours - 0.09;
  return (
    isLateNightCheckout(checkoutTime) &&
    segmentHours > nightShiftMin &&
    segmentHours < almostFullDay
  );
}

export function isSplitDoubleShiftNightComplete(
  totalHours: number,
  fullDayHours: number,
  checkoutTime?: string,
  visits?: unknown[],
  _checkIn?: string,
  _checkOut?: string
): boolean {
  const visitCount = Array.isArray(visits) ? visits.length : 0;
  if (visitCount < 2 && totalHours < fullDayHours * 2 - 0.5) {
    return false;
  }
  const doubleShiftMin = fullDayHours * 2 - 0.5;
  const doubleShiftMax = fullDayHours * 2;
  return (
    isLateNightCheckout(checkoutTime) &&
    totalHours >= doubleShiftMin &&
    totalHours < doubleShiftMax + 0.01
  );
}
